var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.addUserSubAccountShow
    ? _c(
        "div",
        { staticClass: "popup" },
        [
          _c(
            "div",
            { staticClass: "content", attrs: { id: "add-user-sub-account" } },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.subAccountPopup.addUser.title")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon white-close dialog-close",
                  on: {
                    click: function($event) {
                      return _vm.closePage()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-user-sub-account-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "add-user-sub-account-radio",
                    on: {
                      click: function($event) {
                        return _vm.checkRadio(0)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-util radio radio-position",
                      class: [0 == _vm.clickCurrent ? "check-radio" : ""]
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio-content" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.subAccountPopup.addUser.radioCreate"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                0 == _vm.clickCurrent
                  ? _c("div", { staticClass: "add-user-sub-account-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.createName,
                            expression: "createName"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "createName",
                          readonly: _vm.loadingStart,
                          placeholder: _vm.$t(
                            "language.popup.subAccountPopup.addUser.createNamePlaceholder"
                          )
                        },
                        domProps: { value: _vm.createName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.createName = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.createPassword,
                            expression: "createPassword"
                          }
                        ],
                        attrs: {
                          type: "password",
                          name: "createPassword",
                          readonly: _vm.loadingStart,
                          placeholder: _vm.$t(
                            "language.popup.subAccountPopup.addUser.createPasswordPlaceholder"
                          )
                        },
                        domProps: { value: _vm.createPassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.createPassword = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "add-user-sub-account-radio",
                    staticStyle: { "margin-top": "15px" },
                    on: {
                      click: function($event) {
                        return _vm.checkRadio(1)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-util radio radio-position",
                      class: [1 == _vm.clickCurrent ? "check-radio" : ""]
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio-content" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.subAccountPopup.addUser.radioAdd"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                1 == _vm.clickCurrent
                  ? _c("div", { staticClass: "add-user-sub-account-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addUserName,
                            expression: "addUserName"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "addUserName",
                          readonly: _vm.loadingStart,
                          placeholder: _vm.$t(
                            "language.popup.subAccountPopup.addUser.addNamePlaceholder"
                          )
                        },
                        domProps: { value: _vm.addUserName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.addUserName = $event.target.value
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-user-sub-account-footer" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingStart,
                        expression: "loadingStart"
                      }
                    ],
                    on: {
                      click: function($event) {
                        return _vm.addUser()
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("language.common.ok")))])]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5ce74ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ce74ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/sub_account_popups/add_user_popup.vue
// module id = null
// module chunks = 